var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { staticClass: "svg-icon", attrs: { xmlns: "http://www.w3.org/2000/svg" } },
    [
      _c("path", {
        attrs: {
          "clip-rule": "evenodd",
          d: "M16.9 9.44628C16.9 13.5587 13.5645 16.8926 9.45 16.8926C5.33548 16.8926 2 13.5587 2 9.44628C2 5.33381 5.33548 2 9.45 2C13.5645 2 16.9 5.33381 16.9 9.44628ZM14.91 9.44627C14.91 12.4602 12.4655 14.9035 9.44999 14.9035C6.43452 14.9035 3.98999 12.4602 3.98999 9.44627C3.98999 6.4323 6.43452 3.989 9.44999 3.989C12.4655 3.989 14.91 6.4323 14.91 9.44627Z",
          "fill-rule": "evenodd",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.61 21.3603L21.36 21.6102C20.84 22.1299 20 22.1299 19.49 21.6102L13.71 15.8331C13.19 15.3133 13.19 14.4738 13.71 13.964L13.96 13.7141C14.48 13.1944 15.32 13.1944 15.83 13.7141L21.61 19.4913C22.13 20.001 22.13 20.8406 21.61 21.3603Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }